import { rankings, rankItem } from '@tanstack/match-sorter-utils';
import type { FilterFn } from '@tanstack/react-table';

export const fuzzyFilter: FilterFn<any> = (row, columnId, value, addMeta) => {
  // Rank the item
  const itemRank = rankItem(row.getValue(columnId), value, { threshold: rankings.CONTAINS });

  // Store the itemRank info
  addMeta({
    itemRank,
  });

  // Return if the item should be filtered in/out
  return itemRank.passed;
};
